module.exports = __webpack_public_path__ + "images/541581f526f4fa02ae1d315f32330e0d.png";